module.exports = __webpack_public_path__ + "img/map-pin.c0d386f0.svg";